// The label of an app tab in a page's tab bar. The host draws the icon and the
// tooltip, outside the frame, so an app tab can never pass for one of the
// product's own tabs, even when its label is "Templates": the icon and the
// tooltip mark it as an app.

import { t } from '@lingui/core/macro';
import { Flexbox, Tooltip } from '@luminovo/design-system';
import { WorkflowIcon } from 'lucide-react';
import type { ReactElement } from 'react';

export interface AppTabLabelProps {
    /** The tab's label, as `useAppTabs` gives it. */
    label: string;
}

export function AppTabLabel({ label }: AppTabLabelProps): ReactElement {
    return (
        <Tooltip title={t`This tab is an app`} placement="top">
            <Flexbox component="span" gap={4} sx={{ alignItems: 'center' }}>
                <WorkflowIcon size={14} aria-hidden style={{ flexShrink: 0 }} />
                {label}
            </Flexbox>
        </Tooltip>
    );
}
